import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from './Layout';
import FormTemplatesManager from './FormTemplatesManager';

const FormTemplatesPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout 
      title="Form Templates" 
      subtitle="Manage form templates and field configurations"
    >
      <div className="space-y-6">
        {/* Header with back button */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button
              onClick={() => navigate('/settings')}
              className="flex items-center text-gray-600 hover:text-gray-900 transition-colors"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
              Back to Settings
            </button>
          </div>
        </div>

        {/* Full-width FormTemplatesManager */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <FormTemplatesManager
            onClose={() => navigate('/settings')}
            onTemplateUpdate={() => {
              // Handle template updates if needed
              console.log('Template updated');
            }}
            isFullPage={true}
          />
        </div>
      </div>
    </Layout>
  );
};

export default FormTemplatesPage;
